/* eslint-disable @typescript-eslint/no-explicit-any */
import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { useFiltersContext } from '@mercadoni/sinister/dist/cjs/filters/context'
import { memo } from 'react'

const SearchResultLogic = ({ Wrapper }: any) => {
  const { filter: filterCopy } = getLocale() || defaultLocale
  const {
    filters: { searchTerm = '' },
    pagination: { total: { value: totalItems = 0 } = {} },
  } = useFiltersContext()

  return <Wrapper {...{ filterCopy, searchTerm, totalItems }} />
}

export default memo(SearchResultLogic)
